import {
  REMOVE_LICENSE_ALERT,
  SET_LICENSE_ALERT,
  SET_LICENSE_EXPIRY,
  SET_LICENSE_CREATORS,
} from '../actions/types';

const initialState = {
  modal: false,
  expiryDate: undefined,
  creatorSlots: undefined,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_LICENSE_ALERT:
      return { modal: payload.modal, expiryDate: payload.expiryDate, creatorSlots: payload.number_of_creators };
    case REMOVE_LICENSE_ALERT:
      return { ...state, modal: false };
    case SET_LICENSE_EXPIRY:
      return { ...state, expiryDate: payload };
    case SET_LICENSE_CREATORS:
      return { ...state, creatorSlots: payload };
    default:
      return state;
  }
}
